module.exports = __webpack_public_path__ + "static/media/energy2.007d89ef.png";